'use strict'

/* eslint-disable no-eval */
// Charge les différents modules pour la vue correspondante.

import master from 'Modules/master'
import { UpdateWishListCountHeader } from 'Modules/wishList'
import { UpdateAndFlashMiniPanier } from 'Modules/miniPanier'
import {
    InitialiserWishlistInLocalStorage,
    SupprimerArticleWishListInLocalStorage
} from 'Modules/gestionLocalStorage'
import addToBarketVerification from 'Modules/addToBarketVerification'



// TODO
// Refacto layout
addToBarketVerification.setEvent()
master.process()

/**
 * Initialise la wishlist
 */
InitialiserWishlistInLocalStorage(true)

/**
 * Supprimer un élément de la wishlist
 */

const J_DELETE_ITEM = '.wishListItemDelete'

$(J_DELETE_ITEM).click(deleteItemFromWishlist)

function deleteItemFromWishlist() {
    const article = $(this).parents('article')

    $.ajax({
        url: '/WishList/SupprimerArticle',
        data: {
            id: article.data('id')
        },
        success: function (data) {
            // Mets à jour le compte des articles dans le header
            UpdateWishListCountHeader(data.cpt)
            // Supprimer l'item de la wishlist
            SupprimerArticleWishListInLocalStorage(article.data('id'))

            // Mets à jour l'icone de compte d'article sur le coeur
            if (data.cpt < 1) {
                $('.nbWishList').removeClass('isinwishlist')
            }
            $('.nbWishListTotal').html(data.cpt)
        }
    })

    article.remove()
}

/**
 * Sélecteur de tailles
 */

const J_SELECTEUR_TAILLE = '.tailleList'

function addSelecteurTailleEventHandler() {
    $(J_SELECTEUR_TAILLE).on('change', function () {
        $(this)
            .parents('.chevron')
            .siblings('.wishListItemAddPanier')
            .empty()
            .append($t('AJOUTER_PANIER'))
        $(this)
            .parents('.chevron')
            .siblings('.wishListItemAddPanier')
            .removeClass('disabled')
    })
}

addSelecteurTailleEventHandler()

/**
 * Ajouter au panier
 */

const J_AJOUTER_AU_PANIER = '.wishListItemAddPanier'

function setAjouterAuPanierButtonState() {
    $(J_AJOUTER_AU_PANIER).each(function () {
        const article = $(this).parents('article')

        // Vérifies si la taille est sélectionnée
        if (article.find(J_SELECTEUR_TAILLE).val() === '') {
            $(this).empty().append($t('DOIT_SELECTIONNER_TAILLE'))
            $(this).addClass('disabled')
        }
    })
}

setAjouterAuPanierButtonState()

let isAjouterPanierEnCours = false

function addAjouterAuPanierEventHandler() {
    $(J_AJOUTER_AU_PANIER).click(function (e) {
        $('.green').empty()

        const article = $(this).parents('article')
        const id = article.data('id')
        const codeTaille = article.find(J_SELECTEUR_TAILLE).val()

        if (article.find(J_SELECTEUR_TAILLE).val() !== '') {
            if (isAjouterPanierEnCours === false) {
                isAjouterPanierEnCours = true

                $.ajax({
                    url: '/WishList/MisePanierArticle',
                    dataType: 'json',
                    data: {
                        id: id,
                        codetaille: codeTaille
                    },
                    success: function (data) {
                        $('#j_modalConfirmationContent').html(data.modal)
                        const image = document.getElementById("modal-panier-img")
                        image.onload = () => {
                            $('#modal-panier').modal('show')
                        }
                        // Produit indisponible
                        if (data.resultat == 'PRODUIT_INDISPONIBLE') {
                            $('#modal-product-unavailable').modal('show')
                            // on cache le cta découvrir les articles similaires
                            $('#modal-product-unavailable')
                                .find('.btn-primary')
                                .hide()
                            return
                        }

                        // Mets à jour le compte de la wishlist dans le header
                        UpdateWishListCountHeader(data.cpt)

                        if (data.cpt < 1) {
                            $('.nbWishList').removeClass('isinwishlist')
                        }

                        isAjouterPanierEnCours = false

                        eval(data.script)

                        // Mets à jour le compte du panier
                        if ($('.numb-prod').find('strong').length === 0) {
                            $('.numb-prod').append(
                                '<strong class="basket-count">1</strong>'
                            )
                        } else {
                            $('.basket-count').html(
                                parseInt($('.basket-count').html()) + 1
                            )
                        }

                        SupprimerArticleWishListInLocalStorage(
                            article.data('id')
                        )

                        // Mets à jour le compte
                        $(article).fadeOut(1000, function () {
                            article.remove()
                            $('.nbWishListTotal').html(data.cpt)
                        })
                    },
                    error: function () {
                        isAjouterPanierEnCours = false
                    }
                })
            }
        }
    })
}

addAjouterAuPanierEventHandler()

/**
 * Scroll infini
 */

const J_WRAPPER = '.wrapper-wishlist-article'
const J_PAGINATION = '.j_pagination'
const J_AJAX_LOADER_GIF = '.j_loader_gif'

$(window).scrollTop(0)

let page = 1
let isFetchingData = false

$(window).on('scroll', fetchPaginatedArticles)

function fetchPaginatedArticles() {
    // Aucun article dans la wishlist
    if ($(J_WRAPPER).length === 0) {
        return
    }

    const anchorInfinityScroll = $(J_PAGINATION).offset().top

    const userHasReachedBottomOfPage =
        $(window).scrollTop() + $(window).height() === $(document).height()

    if (
        $(this).scrollTop() + $(window).height() * 1.8 > anchorInfinityScroll && // Augmenter le coef. multiplication pour charger en avance la nouvelle page
        !userHasReachedBottomOfPage &&
        !isFetchingData
    ) {
        $(J_AJAX_LOADER_GIF).removeClass('hidden')
        isFetchingData = true
        page++

        $.ajax({
            type: 'GET',
            url: '/Wishlist/GetArticlesInfinityScroll?page=' + page,
            dataType: 'html',
            success: function (html) {
                // Ajoute les articles au DOM
                $(J_WRAPPER).append(html)

                isFetchingData = false
                $(J_AJAX_LOADER_GIF).addClass('hidden')

                // Si on a chargé tous les articles, on enlève la pagination
                if (html == '') {
                    $(window).off('scroll', fetchPaginatedArticles)
                }

                // Ajout event de suppression d'un article de la wishlist
                $(J_DELETE_ITEM).click(deleteItemFromWishlist)

                // Rebind des liens offuscés
                $('.linkAjaxReload').unbind('click')
                $('.linkAjaxReload').on('click', function () {
                    window.location = $(this).attr('data')
                })

                // Définis l'état du bouton ajouter au panier
                setAjouterAuPanierButtonState()

                // Gestion de l'ajout au panier
                addAjouterAuPanierEventHandler()

                // Gestion du sélecteur de taille
                addSelecteurTailleEventHandler()
            }
        })
    }
}
